import { Component } from '@angular/core';

@Component({
  selector: 'app-goldbar',
  templateUrl: './goldbar.component.html',
  styleUrls: ['./goldbar.component.css']
})
export class GoldbarComponent {

}
